import type { Message } from '../model/message'

export function areMessagesEqual(message1: Message, message2: Message) {
  if (message1.id === message2.id) return true
  if (message1.clientId && message1.clientId === message2.clientId) return true
  if (message1.meta?.resentId === message2.id) return true
  if (message2.meta?.resentId === message1.id) return true

  return false
}
